import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import BuildIcon from "@mui/icons-material/Build";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import CommentIcon from "@mui/icons-material/Comment";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import Grid from "@mui/material/Grid";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import InfoIcon from "@mui/icons-material/Info";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import React from "react";
import Typography from "@mui/material/Typography";
import WarningIcon from "@mui/icons-material/Warning";
import { IEvent } from "../declarations";
import { useGetSailInfoTimeline } from "../hooks/useGetSailInfoTimeline";
import { DateTime } from "luxon";
type SailInfoTimelineProps = {
    guid: string;
};

const SailInfoTimeline: React.FC<SailInfoTimelineProps> = ({ guid }) => {
    const { data, isLoading } = useGetSailInfoTimeline(guid);

    if (isLoading || !data) {
        return null;
    }

    function getEventIcon(eventTypeID: number) {
        switch (eventTypeID) {
            case 0:
                // today
                return <EventAvailableIcon />;
            case 1:
                // created
                return <AttachMoneyIcon />;
            case 2:
                // ship
                return <LocalShippingIcon />;
            case 3:
                // feedback
                return <CommentIcon />;
            case 4:
                // warranty
                return <WarningIcon />;
            case 5:
                // info
                return <InfoIcon />;
            case 6:
                // work
                return <BuildIcon />;
            case 7:
                // Service
                return <HomeRepairServiceIcon />;
        }
        return "";
    }
    function getEventTooltip(eventTypeID: number): string {
        switch (eventTypeID) {
            case 0:
                // today
                return "Today in timeline";
            case 1:
                // created
                return "Date the Order was created";
            case 2:
                // ship
                return "Ship Date from this location";
            case 3:
                // feedback
                return "Date Feedback was entered";
            case 4:
                // warranty
                return "Date Warranty work was recorded";
            case 5:
                // info
                return "Date Info is required";
            case 6:
                // work
                return "Date Manufacturing begins at this location";
            case 7:
                // work
                return "Date service item was last updated";
        }
        return "";
    }

    return (
        <Card sx={{ width: "100%" }}>
            <CardHeader title="Timeline" />
            <CardContent>
                <Grid container spacing={2}>
                    {data?.map((item: IEvent, index: number) => (
                        <React.Fragment key={index}>
                            <Grid size={6}>
                                <Typography variant="body1">
                                    {DateTime.fromFormat(
                                        item.date,
                                        "MM/dd/yyyy hh:mm:ss",
                                    ).toLocaleString(DateTime.DATE_MED)}
                                </Typography>
                            </Grid>
                            <Grid size={4}>
                                <Typography variant="body2">
                                    {" "}
                                    {item.event}
                                </Typography>
                            </Grid>

                            <Grid size={2}>
                                <div title={getEventTooltip(item.eventTypeID)}>
                                    {getEventIcon(item.eventTypeID)}
                                </div>
                            </Grid>
                        </React.Fragment>
                    ))}
                </Grid>
            </CardContent>
        </Card>
    );
};

export default SailInfoTimeline;
